import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createSlots as _createSlots } from "vue"

const _hoisted_1 = { class: "card pt-2" }
const _hoisted_2 = { class: "card-header border-0" }
const _hoisted_3 = { class: "card-title m-0 row col-md-5" }
const _hoisted_4 = { class: "fw-bolder m-0" }
const _hoisted_5 = { class: "card-toolbar m-1 p-2" }
const _hoisted_6 = {
  class: "\n            nav nav-stretch\n            fs-5\n            fw-bold\n            nav-line-tabs nav-line-tabs-2x\n            border-transparent\n          ",
  role: "tablist"
}
const _hoisted_7 = {
  class: "nav-item",
  role: "presentation"
}
const _hoisted_8 = { class: "d-flex align-items-center position-relative my-1" }
const _hoisted_9 = { class: "svg-icon svg-icon-1 position-absolute ms-6" }
const _hoisted_10 = {
  class: "nav-item",
  role: "presentation"
}
const _hoisted_11 = { class: "dropdown w-300px p-2" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("li", {
  class: "nav-item",
  role: "presentation"
}, null, -1)
const _hoisted_13 = {
  class: "nav-item",
  role: "presentation"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", {
  style: {"margin-left":"30px"},
  class: "\n        nav-item\n        between:flex\n        bottom:margin-2\n        dataTables_wrapper\n        dt-bootstrap4\n      "
}, null, -1)
const _hoisted_15 = {
  style: {"margin-left":"30px"},
  class: "tableFixHead"
}
const _hoisted_16 = { class: "card-body pt-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_Datatable = _resolveComponent("Datatable")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h6", _hoisted_4, _toDisplayString(_ctx.pagetitle), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("ul", _hoisted_6, [
          _createElementVNode("li", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("span", _hoisted_9, [
                _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen021.svg" })
              ]),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.search = $event)),
                onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.searchItems())),
                class: "form-control form-control-solid w-250px ps-15",
                placeholder: "Search..."
              }, null, 544), [
                [_vModelText, _ctx.search]
              ])
            ])
          ]),
          _createElementVNode("li", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_el_select, {
                modelValue: _ctx.colnames,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.colnames = $event)),
                multiple: "",
                placeholder: _ctx.colnames.length > 0 ? '' : 'please select',
                "collapse-tags": ""
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.OriginalTableHeaders, (item, index) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      value: item.key,
                      key: index
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.name), 1)
                      ]),
                      _: 2
                    }, 1032, ["value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue", "placeholder"])
            ])
          ]),
          _hoisted_12,
          _createElementVNode("li", _hoisted_13, [
            _createElementVNode("button", {
              id: "kt_referrals_year_tab",
              class: "btn btn-sm btn-primary me-3",
              "data-bs-toggle": "tab",
              role: "tab",
              href: "#kt_customer_details_invoices_1",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.downloadItem()))
            }, " Downloads ")
          ])
        ])
      ])
    ]),
    _hoisted_14,
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("div", _hoisted_16, [
        _createVNode(_component_Datatable, {
          "table-data": _ctx.tableValues,
          "table-header": _ctx.OriginalTableHeaders,
          "enable-items-per-page-dropdown": true,
          selectedType: _ctx.colnames
        }, _createSlots({ _: 2 }, [
          _renderList(_ctx.colnames, (slot) => {
            return {
              name: `cell-${slot}`,
              fn: _withCtx(({ row: customer }) => [
                _createTextVNode(_toDisplayString(customer[slot]), 1)
              ])
            }
          })
        ]), 1032, ["table-data", "table-header", "selectedType"])
      ])
    ])
  ]))
}